export type ActionButtonIcon = 'none' | 'edit' | 'plus' | 'tick' | 'loading';
